// extracted by mini-css-extract-plugin
module.exports = {"list":"FooterList_list__MXfqm","item":"FooterList_item__VXm0J"};